import axios from "axios";
import { getSessionId } from "../../../../utils/tokenHandlers";
import UidEmailRoleMatch from "../../../constants/uidEmailRoleMatch";

export const deleteDocumentRecord = (docId: number) => {
  const sessionid = getSessionId();
  const UidEmailRole = UidEmailRoleMatch();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/delete/many/tradexwbench.customer_kyc_document/`,
      {
        params: {
          ...UidEmailRole,
          filter: [["attachment_ids", "=", docId]],
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
        },
      },
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
